import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18n from "i18n";
import useCart from "store";
import Cookie from "js-cookie";
import dayjs from "dayjs";
import "dayjs/locale/ko";

// components
import {
	Stack,
	Button,
	AppBar,
	Typography,
	Container,
	FormControl,
	Select,
	MenuItem,
	Box,
} from "@mui/material";
import { Logo, SvgIconStyle, CommonModal } from "components";
import { ToolbarStyle, ToolbarShadowStyle } from "./HeaderToolbarStyle";

// hooks
import useOffSetTop from "hooks/useOffSetTop";
import useCountdown from "hooks/useCountdown";

// util
import { fDateToKST } from "utils/formatTime";

// icon
import HomeIcon from "assets/icons/home-active.svg";
import Down from "assets/icons/arrow-down.svg";
import Global from "assets/icons/global.svg";
// ----------------------------------------------------------------------

export default function Header({ transparent }) {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const HEADER_DESKTOP_HEIGHT = 96;
	const isScrolling = useOffSetTop(HEADER_DESKTOP_HEIGHT);
	const KIOSK_ID = Cookie.get("Kiosk_ID");

	const [open, setOpen] = useState(null);
	const [time, setTime] = useState(new Date());

	const {
		// language,
		countdown: date,
		festival,
		setLanguage,
	} = useCart((state) => state);
	const { countdown, extendCountdown } = useCountdown(date);

	// 언어 리스트
	const lgArr = [
		{ value: "koKr", label: "한국어" },
		{ value: "enUs", label: "English" },
		{ value: "jaJp", label: "日本語" },
		{ value: "zhCn", label: "中文 (简体)" },
		{ value: "zhTw", label: "中文 (繁體)" },
	];
	const changeLg = (lg) => {
		i18n.changeLanguage(lg);
		setLanguage(lg)
	};

	useEffect(() => {
		const timeCount = setInterval(() => {
			setTime(new Date());
		}, 1000);
		return () => clearInterval(timeCount);
	}, []);
	return(
		<AppBar
			sx={{
				boxShadow: 0,
				bgcolor: "transparent",
				height: "80px",
				position: "relative",
				flexDirection: "row",
				alignItems: "center",
				justifyContent: "space-between",
				px: 6,
				pt: "20px",
			}}
		>
			<Box
				sx={{ display: "flex" }}
				onClick={() => (window.location.href = `/?code=${KIOSK_ID}`)}
			>
				<Logo />
			</Box>

			<Stack direction="row" alignItems="end">
				<FormControl
					size="small"
					sx={{
						width: 140,
						fieldset: { border: "0 !important", borderRadius: 0 },
						"&:hover": { fieldset: { border: 0 } },
						".MuiSelect-select": {
							borderBottom: "0 !important",
							p: 0,
							display: "flex",
							alignItems: "center",
							gap: 1.5,
							"&:before": {
								background: `center/contain no-repeat url(${Global})`,
								content: '""',
								display: "block",
								height: 24,
								minWidth: 24,
							},
						},
					}}
				>
					<Select
						defaultValue="koKr"
						value={i18n.language}
						label="한국어"
						onChange={(e) => i18n.changeLanguage(e.target.value)}
						IconComponent={() => <SvgIconStyle src={Down} size={16} />}
					>
						{lgArr.map((lg) => (
							<MenuItem
								value={lg.value}
								key={lg.value}
								sx={{
									px: 3,
									py: 2,
								}}
								onClick={() => changeLg(lg.value)}
							>
								<Typography variant="subtitle2">{lg.label}</Typography>
							</MenuItem>
						))}
					</Select>
				</FormControl>

				<Typography
					color="primary.main"
					variant="h4"
					sx={{ textDecoration: "underline", px: 4, lineHeight: "30px" }}
				>
					{`
					${
					dayjs(Cookie.get("qs_kiosk_date") || new Date()).format(i18n.language === "koKr" ? "MM월 DD일" : "MMM D")
						}
					 ${dayjs(time).locale("ko").format("HH:mm")}`}
				</Typography>

				<Box sx={{ display: "flex" }} onClick={() => navigate("/menus")}>
					<SvgIconStyle src={HomeIcon} origin size={36} />
				</Box>
			</Stack>

			{isScrolling && <ToolbarShadowStyle />}
		</AppBar>
	);
}
